import { useEffect, useState } from 'react';
import { API_URL } from '../constants';
import { httpClient } from '../providers/httpClient';

export interface PendingCounts {
  commentReports: number;
  questionReports: number;
}

// Polls the pending-report counts for the admin menu badges. Best-effort: any
// error just leaves the counts at their last value (the badge is informational).
export const usePendingCounts = (pollMs = 60000): PendingCounts => {
  const [counts, setCounts] = useState<PendingCounts>({
    commentReports: 0,
    questionReports: 0,
  });

  useEffect(() => {
    let active = true;

    const load = async () => {
      try {
        const { json } = await httpClient(`${API_URL}/moderation/pending-counts`);
        if (active && json) {
          setCounts({
            commentReports: Number(json.commentReports) || 0,
            questionReports: Number(json.questionReports) || 0,
          });
        }
      } catch {
        // ignore — the badge is informational only
      }
    };

    load();
    const timer = setInterval(load, pollMs);
    return () => {
      active = false;
      clearInterval(timer);
    };
  }, [pollMs]);

  return counts;
};
